import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-23-uday-narang-guest.webp";
import ThumbImg from "../../assets/images/conversations/023.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: un2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .un2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .un2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .un2-hero { padding-top: 60px; padding-bottom: 60px; }
  .un2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .un2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .un2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un2-hero__title.un2-visible { opacity: 1; transform: translateY(0); }
  .un2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .un2-hero__spotify.un2-visible { opacity: 1; transform: translateY(0); }
  .un2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .un2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .un2-hero__right.un2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .un2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .un2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .un2-yt-thumb:hover img { opacity: 0.85; }
  .un2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .un2-yt-thumb__play img { width: 40px; height: 44px; }
  .un2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .un2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .un2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un2-body.un2-visible { opacity: 1; transform: translateY(0); }
  .un2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .un2-body__para:last-child { margin-bottom: 0; }
  .un2-body__link {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%;
    word-break: break-all;
  }

  /* ── GUEST ── */
  .un2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un2-guest.un2-visible { opacity: 1; transform: translateY(0); }
  .un2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .un2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .un2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .un2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .un2-inner { padding-left: 32px; padding-right: 32px; }
    .un2-hero { padding-top: 32px; padding-bottom: 48px; }
    .un2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .un2-hero__title { font-size: 24px; }
    .un2-hero__left { gap: 16px; }
    .un2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .un2-guest__photo-bg { width: 260px; height: 300px; }
    .un2-guest__name { font-size: 24px; margin-top: 18px; }
    .un2-body__para { font-size: 14px; margin-bottom: 12px; }
    .un2-body__link { font-size: 14px; }
    .un2-body { padding-bottom: 48px; }
    .un2-guest { padding-bottom: 48px; }
    .un2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .un2-inner { padding-left: 16px; padding-right: 16px; }
    .un2-hero { padding-top: 51px; padding-bottom: 30px; }
    .un2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .un2-hero__left { gap: 30px; }
    .un2-hero__title { font-size: 30px; }
    .un2-body__para { font-size: 16px; margin-bottom: 10px; }
    .un2-body__link { font-size: 16px; }
    .un2-guest__title { font-size: 30px; margin-bottom: 20px;text-align:left; }
    .un2-guest__photo-bg { width: 100%; height: 386px; }
    .un2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .un2-body { padding-bottom: 30px; }
    .un2-guest { padding-bottom: 30px; }
    .un2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("un2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "GdTbTgcx1UQ";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="un2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 23 Uday Narang Omega Seiki Mobility"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="un2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 23 Uday Narang thumbnail" />
      <div className="un2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="un2-hero">
      <div className="un2-inner">
        <div className="un2-hero__grid">
          <div className="un2-hero__left">
            <h1 ref={titleRef} className="un2-hero__title">
              EP 23 | The Power Behind Real Sustainable Last Mile Deliveries | Omega Seiki Mobility | Uday NARANG
            </h1>
            <div ref={spotifyRef} className="un2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2VqWHku55SSMTKWYU4erJ0?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 23 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="un2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="un2-body">
      <div className="un2-inner">
        <p className="un2-body__para">
          In this episode we go back to the OEM sector and speak to none other than Uday NARANG, Founder &amp; CEO of Omega Seiki Mobility. Uday is nurturing this company to become the Tesla of the east for cargo EVs. Driven by data and analytics and a relentless focus on quality, Omega Seiki Mobility has become synonymous to India's sustainability solutions for last-mile delivery. Uday is having a wonderful time making the rest of the industry uncomfortable. Listen here to find out why!
        </p>
        <p className="un2-body__link">
          https://www.youtube.com/watch?v=GdTbTgcx1UQ
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="un2-guest">
      <div className="un2-inner">
        <h2 className="un2-guest__title">Our Guest</h2>
        <div>
          <div className="un2-guest__photo-bg">
            <img src={GuestImg} alt="Uday Narang" />
          </div>
          <p className="un2-guest__name">Uday NARANG</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep23UdayNarang() {
  return (
    <>
      <style>{CSS}</style>
      <div className="un2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}